import { MediaLayer } from "./MediaLayer";
import type { PullQuoteData } from "./schemas";

export default function PullQuote(props: PullQuoteData) {
  const hasMedia = !!props.background_media?.url;
  return (
    <section
      className="relative w-full overflow-hidden flex items-center justify-center px-8 py-24"
      style={{ minHeight: hasMedia ? "80svh" : undefined }}
    >
      {hasMedia && (
        <>
          <MediaLayer media={props.background_media} alt="background" />
          <div className="absolute inset-0 bg-black/55" />
        </>
      )}
      <div className="relative z-10 max-w-[28ch] text-center">
        {props.quote && (
          <blockquote className="font-serif italic text-2xl md:text-3xl leading-snug text-foreground text-shadow-soft">
            &ldquo;{props.quote}&rdquo;
          </blockquote>
        )}
        {props.attribution && (
          <div className="mt-5 text-[10px] tracking-[0.35em] uppercase text-gold/90">
            — {props.attribution}
          </div>
        )}
      </div>
    </section>
  );
}
